import { z } from 'zod';
import { AuthorizedClient } from '~/app-modules/core/clients/authorized-client';
import { HttpConnection } from '~/app-modules/core/clients/http-connection';
import { AuthService } from '~/app-modules/auth/services/auth-service';
import { UserResponse } from '~/app-modules/user/clients/dto/user-response';
import { UserStore } from '~/app-modules/user/stores/user.store';

@singleton()
export class UserClient extends AuthorizedClient {
  constructor(http: HttpConnection, authService: AuthService, userStore: UserStore) {
    super(http, authService, userStore);
  }

  /**
   *  Получение информации о текущем юзере
   */
  async getAll() {
    return await this.executeRequest(
      {
        method: 'get',
        url: '/ui/v1/user/all',
      },
      z.array(UserResponse),
    );
  }
}
